import React, { memo } from 'react';
import PropTypes from 'prop-types';

const SquareFeetThick = ({ color, ...props }) => (
  <svg viewBox="0 0 24 24" {...props}>
    <g
      stroke={color}
      strokeWidth={props.strokeWidth || 1.25}
      fillOpacity="0"
      strokeLinejoin="round"
      strokeMiterlimit="10"
    >
      <path
        strokeLinecap="round"
        d="M9.5 16.5v6h11v-6M6.5 16l8.5-8.5 8.5 8.5M19 8.5h3.5v3.5"
      />
      <path strokeLinecap="round" d="M13.5 12.5h3v3h-3z" />
      <path d="M.5 4.5h4v18h-4zM4.5.5h18v4h-18zM.5.5h4v4h-4zM7.5 4.5v-2.5M11.5 4.5v-2.5M15.5 4.5v-2.5M19.5 4.5v-2.5M4.5 19.5h-2.5M4.5 15.5h-2.5M4.5 11.5h-2.5M4.5 7.5h-2.5" />
    </g>
  </svg>
);

SquareFeetThick.defaultProps = {
  width: 40,
  height: 40,
  color: 'currentColor',
};

SquareFeetThick.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

export default memo(SquareFeetThick);
